import React, { useState } from "react";
import "../../style/admin/TicketSupportTable.css";
import { sendEmailResponse, sendTelegramResponse } from "../../utils/api";

const TicketSupportTable = ({ tickets }) => {
  const [searchText, setSearchText] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Filter tickets berdasarkan search
  const filteredTickets = tickets.filter((ticket) => {
    const matchesSearch =
      searchText === "" ||
      ticket.user_email?.toLowerCase().includes(searchText.toLowerCase()) ||
      ticket.subject?.toLowerCase().includes(searchText.toLowerCase());

    const matchesFilter = filterStatus === "" || ticket.status === filterStatus;

    return matchesSearch && matchesFilter;
  });

  // Pagination
  const totalPages = Math.ceil(filteredTickets.length / itemsPerPage);
  const paginatedTickets = filteredTickets.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
  };

  const handleFilterChange = (e) => {
    setFilterStatus(e.target.value);
    setCurrentPage(1);
  };

  // Generate page numbers
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      if (currentPage <= 3) {
        endPage = 4;
      }

      if (currentPage >= totalPages - 2) {
        startPage = totalPages - 3;
      }

      if (startPage > 2) {
        pages.push("...");
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < totalPages - 1) {
        pages.push("...");
      }

      if (totalPages > 1) {
        pages.push(totalPages);
      }
    }

    return pages;
  };

  // Fungsi untuk mengirim balasan lewat email
  const handleSendEmail = async (ticketId, email) => {
    const responseMessage = "Your issue has been resolved";
    try {
      await sendEmailResponse(ticketId, responseMessage);
      alert("Balasan telah dikirim lewat email ke: " + email);
    } catch (error) {
      alert("Gagal mengirim balasan lewat email");
    }
  };

  // Fungsi untuk mengirim balasan lewat Telegram
  const handleSendTelegram = async (ticketId, phoneNumber) => {
    const responseMessage = "Your issue has been resolved";
    try {
      await sendTelegramResponse(ticketId, phoneNumber, responseMessage);
      alert("Balasan telah dikirim lewat Telegram ke: " + phoneNumber);
    } catch (error) {
      alert("Gagal mengirim balasan lewat Telegram");
    }
  };

  return (
    <div className="ticket-container">
      <div className="ticket-card">
        <h3 className="ticket-subtitle">Ticket List Requests</h3>

        {/* Toolbar - Sticky di mobile */}
        <div className="ticket-toolbar">
          <input
            type="text"
            className="ticket-search"
            placeholder="Search by email or message..."
            value={searchText}
            onChange={handleSearchChange}
          />
          <select
            className="ticket-filter"
            value={filterStatus}
            onChange={handleFilterChange}
          >
            <option value="">All Status</option>
            <option value="open">Open</option>
            <option value="in-progress">In Progress</option>
            <option value="resolved">Resolved</option>
            <option value="closed">Closed</option>
          </select>
        </div>

        {/* Table Container dengan Scroll */}
        <div className="table-wrapper-ticket">
          <table className="ticket-table">
            <thead>
              <tr>
                <th>No.</th>
                <th>Email</th>
                <th>Message</th>
                <th>Received Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedTickets.length > 0 ? (
                paginatedTickets.map((ticket, index) => (
                  <tr key={ticket.id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{ticket.user_email}</td>
                    <td>{ticket.subject}</td>
                    <td>{new Date(ticket.created_at).toLocaleDateString()}</td>
                    <td className="ticket-action">
                      <button
                        className="icon-btn"
                        onClick={() => handleSendEmail(ticket.id, ticket.user_email)}
                      >
                        ✉️ Email
                      </button>
                      <button
                        className="icon-btn"
                        onClick={() =>
                          handleSendTelegram(ticket.id, ticket.user_whatsapp_number)
                        }
                      >
                        📤 Telegram
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="empty-row">
                    {searchText || filterStatus
                      ? "No matching tickets found"
                      : "No tickets available"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer dengan Pagination */}
        <div className="ticket-footer">
          <span>
            Showing {paginatedTickets.length} of {filteredTickets.length} tickets
          </span>
          {totalPages > 1 && (
            <div className="pagination">
              <button
                className="page-btn"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {"<"}
              </button>
              {getPageNumbers().map((page, idx) => (
                <button
                  key={idx}
                  className={`page-btn ${page === currentPage ? "active" : ""}`}
                  onClick={() => handlePageChange(page)}
                  disabled={page === "..."}
                >
                  {page}
                </button>
              ))}
              <button
                className="page-btn"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                {">"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketSupportTable;